<template>
	<v-toolbar
		class="secondary"
		flat
		height="47"
		tabs
	>
		<v-tabs
			v-model="tabs.activeTab"
			color="transparent"
			fixed-tabs
			slider-color="info"
			@change="activeTab"
		>
			<v-tab
				class="text-capitalize body-1 font-weight-regular navbartext--text"
				v-for="item in tabs.items"
				:key="item"
				:href="'#tab-' + item"
			>
				{{ item }}
			</v-tab>
		</v-tabs>
	</v-toolbar>
</template>

<script>
import { mapState } from 'vuex'

export default {
	computed: {
		...mapState(['tabs']),
	},
	methods: {
		activeTab(tab) {
			this.$store.commit('setTabs', {activeTab: tab})
		}
	}

}
</script>